import { useFlags } from "@resource/client-ffs";
import { CustomerPlanEnum } from "@resource/common";
import { useAuthContext } from "auth/context";
import withPageAuthRequired from "auth/withPageAuthRequired";
import Feedback from "components/Feedback/Feedback";
import GatedFeedbackUpsell from "components/Feedback/GatedFeedbackUpsell";
import Layout from "components/Layout";
import FeatureFlags from "generated/FeatureFlags";
import { PermissionEnum } from "utils/permissions";

function FeedbackPage() {
  const {
    [FeatureFlags.ENABLE_FEEDBACK_ADDON]: enableFeedbackAddon,
    [FeatureFlags.GATED_FEEDBACK_LANDING_PAGE]: enableGatedFeedbackLandingPage,
    [FeatureFlags.CANDIDATE_FEEDBACK_ZEUS]: zeusCandidateFeedbackEnabled,
  } = useFlags();
  const {
    zeusInfo: { isZeus },
  } = useAuthContext();

  return !enableGatedFeedbackLandingPage ||
    (enableGatedFeedbackLandingPage && enableFeedbackAddon) ||
    (isZeus && zeusCandidateFeedbackEnabled) ? (
    <Feedback />
  ) : (
    <GatedFeedbackUpsell />
  );
}

export default withPageAuthRequired(FeedbackPage, {
  requiredPlan: CustomerPlanEnum.Platform,
  requiredPermissions: PermissionEnum.ANALYTICS_READ,
  getLayout: (page) => <Layout>{page}</Layout>,
});
